<script lang="ts" setup>
import { computed } from 'vue';

import Header4 from '@/components/base/typography/Header4.vue';
import Review from '@/components/pdp/reviews/Review.vue';
import { ApprovedReviews } from '@/lib/reviews';
import { NutsProductVariant } from '@/utils/product';

const props = defineProps<{
  productImage?: string;
  productKey: string;
  productName: string;
  reviews: ApprovedReviews;
  selectedVariant: NutsProductVariant;
}>();

const displayReviews = computed(() =>
  [
    props.reviews.featuredReview,
    props.reviews.mostRecentTopRatedReviewsOver100Chars[0],
    props.reviews.reviews[0],
    props.reviews.reviews[1],
  ]
    .filter((review, index, self) => review && self.findIndex((r) => r?.id === review.id) === index)
    .slice(0, 2),
);
</script>

<template>
  <div v-if="displayReviews.length">
    <Header4 headerTag="h2">Customer Reviews</Header4>
    <div v-for="(review, index) in displayReviews" :key="`review-${index}`">
      <Review
        v-if="review"
        class="mt-2"
        :featured="review === reviews.featuredReview"
        :review="review"
      />
    </div>
  </div>
</template>
